export const locationById = (state, rootState, getters, rootGetters) => locationId => {
  return rootGetters['entities/Location'](locationId);
};

export const formatAsLocationCurrency = (state, rootState, getters, rootGetters) => ({ locationId, number }) => {
  const location = locationById(state, rootState, getters, rootGetters)(locationId);
  return (number / 100).toLocaleString(location.locale, { style: 'currency', currency: location.currency });
};

export const tierPriceToLocationPrice = (state, rootState, getters, rootGetters) => ({ locationId, tierPrice }) => {
  const location = locationById(state, rootState, getters, rootGetters)(locationId);
  let price = tierPrice;
  if (location.taxExclusive) {
    price = Math.round(tierPrice + (tierPrice * (location.taxAmount / 100)));
  }
  return Math.round(price);
};
